import script from "./afterSales.vue?vue&type=script&setup=true&lang=js"
export * from "./afterSales.vue?vue&type=script&setup=true&lang=js"

import "./afterSales.vue?vue&type=style&index=0&id=110abaa3&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-110abaa3"]])

export default __exports__